import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot } from "@angular/router";
import { DataService } from './data.service';

@Injectable({
  providedIn: "root"
})
export class HomeguardService   {
  constructor(public router: Router, public data: DataService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.data.progress == undefined || this.data.progress.code == undefined) {
      if (this.data.pathway?.show_timeline_page == 1) {
        this.router.navigateByUrl('/recoverytimeline');
        return false;
      }
      if (this.data.pathway?.show_traffic_light_page == 1) {
        this.router.navigateByUrl('/feedbackinput');
        return false;
      }
      return true;
    }

    return true;
  }
}